import React, { useEffect, useState } from "react";

import Select from "react-select";

import { bancos } from "../../utils/helpers";
import { apiRequest } from "../../hooks/apiRequest";

export const OPCIONES_VENCIMIENTO = [
	{ value: "todos", label: "Todos" },
	{ value: "no_vencidas", label: "No Vencidas" },
	{ value: "7-", label: "Vencidas 7 días o menos" },
	{ value: "8_15", label: "Vencidas 8 a 15 días" },
	{ value: "16_30", label: "Vencidas 16 días a 30 días" },
	{ value: "31-45", label: "Vencidas 31 días a 45" },
	{ value: "46+", label: "Vencidas mas de 46 días" },
];

export const TarjetaInfo = () => {
	return (
		<>
			<div className="form-group">
				<label className="label form-control-label">
					Institución Financiera:
				</label>
				<Select
					isClearable
					options={bancos}
                    required
                    menuPosition='fixed'
                    menuPlacement='auto'
					name="metodo_pago[banco]"
				/>
			</div>
			<div className="form-group">
				<label>Terminal de tarjeta</label>
				<input
					type="text"
                    required
					name="metodo_pago[terminal_tarjeta]"
					// defaultValue={detalleMetodoPago?.terminal_tarjeta}
					className="form-control"
				/>
			</div>
			<div className="form-group">
				<label>Tipo</label>
				<select className="form-control" name="metodo_pago[tipo]" required>
					<option value="">- Seleccionar -</option>
					<option value="visa">Visa</option>
					<option value="mastercard">Mastercard</option>
					<option value="otro">Otro</option>
				</select>
			</div>
			<div className="form-group">
				<label>Numero de aprobación</label>
				<input
					type="text"
					className="form-control"
					name="metodo_pago[num_aprobacion]"
                    required
					// defaultValue={detalleMetodoPago?.num_aprobacion}
				/>
			</div>
		</>
	);
};

// Chequera + número de cheque, con la secuencia que sigue la numeración del
// banco. Lo usan el pago de una compra (`ChequeInfoPago`, que además refleja lo
// elegido en el estado del formulario) y las cuentas por pagar
// (`ChequeInfoPagar`, que sólo manda los valores por su `name`). Eran dos copias
// del mismo formulario; las diferencias que quedaban son las props de abajo.
const ChequeInfoNumeracion = ({
	cuenta,
	setPagoInfo = () => {},
	seguirSecuenciaName,
	bloquearSelectSinSecuencia = false,
}) => {
	const [numero, setNumero] = useState('');
    const [seguirSecuencia, setSeguirSecuencia] = useState(true);
	const [numeraciones, setNumeraciones] = useState([]);

	const getNumeraciones = async () => {
		if (cuenta?.banco){
			const table = await apiRequest({}, `numeracion-documentos?buscar=cheque&banco=${cuenta.banco}`, 'get');
			if (table.data) {
				setNumeraciones(table.data.map(item => ({value: item.id, label: `${item.prefijo} - ${item.nombre}`})));
			}
		} else {
			setNumeraciones([]);
		}
	};

    const getNumeracionSiguiente = async (id) => {
        const response = await apiRequest(null, 'numeracion-documentos/siguiente/' + id, 'get');
        if (response.data) {
            const numero = response.data.tipo ? response.data.tipo +  response.data.numero_siguiente : '';
            setNumero(numero);
            setPagoInfo((info) => ({
                ...info,
                num_cheque: numero,
            }));
        }
    }

	useEffect(() => {
		getNumeraciones();
	}, [cuenta]);

	return (
		<>
            <div className='form-group'>
                <label className='label form-control-label'>
					Nombre de chequera:
                </label>
                <div className="row">
                    <div className="col-md-7 d-flex">
                        <input type="checkbox" name={seguirSecuenciaName} value="si" className="m-r-15" onChange={e => setSeguirSecuencia(!seguirSecuencia)} checked={seguirSecuencia} disabled={!cuenta} title="Seguir Secuencia" />
                        <div style={{flex: 1}}>
						<Select
							isClearable
							isDisabled={!cuenta || (bloquearSelectSinSecuencia && !seguirSecuencia)}
							options={numeraciones}
							menuPosition='fixed'
							menuPlacement='auto'
							name="metodo_pago[numeracion_id]"
							onChange={ e => {
								getNumeracionSiguiente(e.value);
								setPagoInfo((info) => ({
									...info,
									numeracion_id: e.value,
								}));
							}}
						/>
                        </div>
                    </div>
                    <div className="col-md-5">
                    <input
                        type='text'
                        name="metodo_pago[num_cheque]"
                        required
                        readOnly={!cuenta || seguirSecuencia}
                        className='text-input form-control'
                        defaultValue={numero}
						onChange={ e => {
                            e.persist();
							setPagoInfo((info) => ({
								...info,
								num_cheque: e.target.value,
							}));
						}}
                    />
                    </div>
                </div>
            </div>
		</>
	);
};

export const ChequeInfoPago = ({cuenta, setPagoInfo}) => (
	<ChequeInfoNumeracion
		cuenta={cuenta}
		setPagoInfo={setPagoInfo}
		seguirSecuenciaName="metodo_pago[seguir_secuencia]"
		bloquearSelectSinSecuencia
	/>
);

export const ChequeInfoPagar = ({cuenta}) => (
	<ChequeInfoNumeracion cuenta={cuenta} seguirSecuenciaName="seguir_secuencia" />
);

export const ChequeInfoCobrar = () => {
	return (
		<>
			<div className="form-group">
				<label className="label form-control-label">
					Institución Financiera:
				</label>
				{/* <Select
					isClearable
					options={bancos}
                    menuPosition='fixed'
                    menuPlacement='auto'
                    isRequired={true}
					name="metodo_pago[banco]"
				/> */}
				<select className="form-control" name="metodo_pago[banco]" required>
					<option value="">- Seleccionar -</option>
					{bancos.map((banco) => (
						<option key={banco.value} value={banco.value}>
							{banco.label}
						</option>
					))}
				</select>
			</div>
            <div className='form-group'>
                <label className='label form-control-label'>
                    Número de cheque:
                </label>
                <div>
                    <input
                        type='text'
                        name="metodo_pago[num_cheque]"
                        required
                        className='text-input form-control'
                    />
                </div>
            </div>
		</>
	);
};

export const TransferenciaInfo = () => {
	return (
		<>
			<div className="form-group">
				<label className="label form-control-label">
					Institución Financiera:
				</label>
				<Select
					isClearable
					options={bancos}
                    menuPosition='fixed'
                    menuPlacement='auto'
                    required
					name="metodo_pago[banco]"
				/>
			</div>
			<div className="form-group">
				<label>Numero de Transferencia</label>
				<input
					type="text"
					name="metodo_pago[num_transferencia]"
					className="form-control"
				/>
			</div>
		</>
	);
};

export const DepositoInfo = () => {
	return (
		<>
			<div className="form-group">
				<label>Numero de Depósito</label>
				<input
					type="text"
					name="metodo_pago[num_deposito]"
                    required
					className="form-control"
				/>
			</div>
		</>
	);
};

export const OtroInfo = () => {
	return (
		<>
			<div className="form-group">
				<label>Numero de transacción</label>
				<input
					type="text"
					name="metodo_pago[num_transaccion]"
                    required
					className="form-control"
				/>
			</div>
		</>
	);
};
